import { useState } from 'react';
import { AsyncDataHandler } from '@ds';
import { useGetUser } from 'src/shared/queries/useGetUser';
import { useGetCaseList } from 'src/shared/queries/useGetCaseList';
import { useImmigrationInstanceStore } from 'src/stores/ImmigrationInstanceStore';
import { shouldSkipGlobalCaseTransitionModal } from 'src/utils/services/case';
import GlobalCaseTransitionModal, {
  GlobalCaseTransitionModalType,
} from 'src/components/GlobalCaseTransitionModal/GlobalCaseTransitionModal';
import { CrossInstanceLabels } from 'src/utils/constants/common';
import { useGetRemoteBeneficiaryId } from 'src/shared/queries/useGetRemoteBeneficiaryId';
import RemoteInfoBanner from 'src/components/RemoteInfoBanner/RemoteInfoBanner';
import { getRemoteInstanceRedirectURL } from 'src/utils/services/common';

const RemoteDocsBanner = (props: { pathname: string; type: GlobalCaseTransitionModalType; classNames?: string }) => {
  const { pathname, type, classNames = '' } = props;
  const { data: userInfo } = useGetUser();
  const { immigrationInstance } = useImmigrationInstanceStore();
  const beneId = userInfo?.beneId ? Number(userInfo.beneId) : 0;
  const { data: cases, isLoading: isCasesLoading } = useGetCaseList(beneId, true);
  const hasRemoteCases = !!cases?.some((caseItem) => (caseItem.remoteCaseId || 0) > 0);
  const { data: remoteBeneficiaryId } = useGetRemoteBeneficiaryId(hasRemoteCases && beneId ? beneId : 0);
  const [isGlobalCaseTransitionModalOpen, setIsGlobalCaseTransitionModalOpen] = useState(false);

  const goToDocuments = () => {
    if (!hasRemoteCases) return;

    if (shouldSkipGlobalCaseTransitionModal()) {
      checkAndRedirectToRemoteImmigrationDocuments();
    } else {
      setIsGlobalCaseTransitionModalOpen(true);
    }
  };

  const checkAndRedirectToRemoteImmigrationDocuments = () => {
    if (!remoteBeneficiaryId) return;

    const targetUrl = `${window.FN_CONFIG.CROSS_INSTANCE_FN_URL}/${pathname}`;
    window.open(getRemoteInstanceRedirectURL(targetUrl), '_blank');
  };

  return (
    <>
      <AsyncDataHandler isLoading={isCasesLoading}>
        {hasRemoteCases && immigrationInstance && (
          <div className={classNames}>
            <RemoteInfoBanner
              title={`You have cases managed by ${CrossInstanceLabels[immigrationInstance]}.`}
              buttonInfo={{
                text: 'VIEW DOCUMENTS',
                disabled: !remoteBeneficiaryId,
                onClick: goToDocuments,
              }}
            />
          </div>
        )}
      </AsyncDataHandler>

      <GlobalCaseTransitionModal
        isModalOpen={isGlobalCaseTransitionModalOpen}
        modalType={type}
        onModalClose={() => setIsGlobalCaseTransitionModalOpen(false)}
        onNavigate={() => checkAndRedirectToRemoteImmigrationDocuments()}
      />
    </>
  );
};

export default RemoteDocsBanner;
